import { defineMessages } from 'react-intl';

import { CountryCodes } from 'src/common/enums';

export const defaultTitleAndDescription = {
  description:
    'Explore internships, graduate jobs & career development resources on Glints. ' +
    'Do what you love on our career discovery & development platform.',
  title: 'Glints - Career Discovery & Development Platform',
};

export const countrySpecificMetadata = defineMessages({
  [CountryCodes.ID]: {
    title: {
      id: 'id-landing-page_meta_title',
      defaultMessage:
        'Glints TapLoker | Indonesia Best Job Search & Hiring Marketplace',
    },
    description: {
      id: 'id-landing-page_meta_description',
      defaultMessage: `Unlock your career potential with Glints TapLoker! Discover 30,000+ active job opportunities, connect with top employers, and apply in just one tap. Take the next big step in your professional journey today!`,
    },
  },
  [CountryCodes.MY]: {
    title: {
      id: 'my-landing-page_meta_title',
      defaultMessage:
        'Glints | Jobs and Internships for Young Professionals in Malaysia',
    },
    description: {
      id: 'my-landing-page_meta_description',
      defaultMessage:
        'Explore internships, graduate jobs & career development resources in Malaysia on ' +
        'Glints. Do what you love on our career discovery & development platform.',
    },
  },
  [CountryCodes.SG]: {
    title: {
      id: 'sg-landing-page_meta_title',
      defaultMessage:
        'Glints | Jobs and Internships for Young Professionals in Singapore',
    },
    description: {
      id: 'sg-landing-page_meta_description',
      defaultMessage:
        'Discover Singapore careers, internships, graduate jobs & career advice on Glints, ' +
        'the #1 jobs marketplace for young professionals.',
    },
  },
  [CountryCodes.TW]: {
    title: {
      id: 'tw-landing-page_meta_title',
      defaultMessage:
        'Jobs, Career Advice, Recruitment Service | Glints Taiwan',
    },
    description: {
      id: 'tw-landing-page_meta_description',
      defaultMessage:
        '{time} popular jobs - Glints provides latest and high-quality job openings of Tech industry. You can find famous startups and enterprises on our job search platform. Glints also provides headhunting services for employers.',
    },
  },
  [CountryCodes.VN]: {
    title: {
      id: 'vn-landing-page_meta_title',
      defaultMessage: 'Glints | Vietnam Best Job Search & Hiring Marketplace',
    },
    description: {
      id: 'vn-landing-page_meta_description',
      defaultMessage: defaultTitleAndDescription.description,
    },
  },
});
